module.exports = __webpack_public_path__ + "img/coin-panel.3d66e944.png";